var styleDataHash = "ebe0cf67";
const injectCss = (() => {
  var css = `.-kesc{--shimmer-base-color:#f5f5f5;background-color:var(--shimmer-base-color);pointer-events:none;z-index:1}.-kesc,.TGlEL{inset:0;position:absolute}.TGlEL{overflow:hidden}.TGlEL:after{animation:hAddx 1s linear infinite;background:linear-gradient(90deg,transparent,hsla(0,0%,100%,.3),transparent 50%);bottom:0;content:"";left:0;position:absolute;right:0;top:0;transform:translateX(-100%)}@keyframes hAddx{to{transform:translateX(100%)}}.WN2UJ{bottom:12px;left:50%;position:absolute;transform:translateX(-50%);z-index:2}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var layout_background_loader_default = {
  "overlay": "-kesc",
  "shimmer": "TGlEL",
  "layout-shimmer": "hAddx",
  "label": "WN2UJ"
};
export {
  layout_background_loader_default as default,
  injectCss
};
//# sourceMappingURL=layout-background-loader-scss.js.map
